export function shouldRenderLocationMapIframe(hasRequestedMap: boolean) {
    return hasRequestedMap;
}
